/**
 * Design System Tokens
 * Central export for all design tokens
 */

export { colors } from './colors';
export { typography } from './typography';
export { spacing, layout, radius, shadows, zIndex } from './spacing';
export { duration, easing, transitions, keyframes, animations } from './animations';

// Combined tokens object for convenience
export const tokens = {
  colors: require('./colors').colors,
  typography: require('./typography').typography,
  spacing: require('./spacing').spacing,
  layout: require('./spacing').layout,
  radius: require('./spacing').radius,
  shadows: require('./spacing').shadows,
  zIndex: require('./spacing').zIndex,
  duration: require('./animations').duration,
  easing: require('./animations').easing,
  transitions: require('./animations').transitions,
  animations: require('./animations').animations,
}; 